import React from "react";
import styled, { css } from "styled-components";

export const containerStyles = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  box-sizing: border-box;

  @media (max-width: 768px) {
    flex-direction: column !important;
  }
`;

const StyledContainer = styled.div`
  ${containerStyles}
`;

export function Container({
  children,
  className = "",
  style = {},
  ...stylesAsProps
}) {
  return (
    <StyledContainer
      className={className}
      style={{ ...style, ...stylesAsProps }}
    >
      {children}
    </StyledContainer>
  );
}
